<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb
      :crumbs="[{ 'path': 'clients', 'name': 'Clients'}, { 'name': `${client.client_name}`}]"
    />
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-form :layout="formLayout" :form="form" :key="componentKey">
        <a-collapse accordion defaultActiveKey="1">
          <a-collapse-panel header="General" key="1">
            <a-client-general
              :formLayout="formLayout"
              :size="size"
              :data="client"
              :options="options"
            />
          </a-collapse-panel>
          <a-collapse-panel header="Allowed Claims" key="2">
            <a-client-claims
              :formLayout="formLayout"
              :size="size"
              :data="client"
              :options="options"
            />
          </a-collapse-panel>
          <a-collapse-panel header="Redirect URIs" key="3">
            <a-multiple-uris
              :form="form"
              varName="redirect_uris"
              varLabel="Redirect URIs"
              :varInitial="client.redirect_uris"
              v-if="client.application_type === 'native'"
              description="For native mobile applications privide one or more valid custom schema URIs, e.g. <pre>io.axioms.us.control.app://callback</pre>For native desktop app you can provide Loopback IP address, e.g. <pre>http://127.0.0.1:51004/oauth2/callback</pre>Please <a href='https://developer.axioms.io/docs/getting-started/client/configure/redirect-uris' target='_blank'>→ review the documentation</a> on Client redirect URI schemes."
            />
            <a-multiple-urls
              :form="form"
              varName="redirect_uris"
              varLabel="Redirect URIs"
              :varInitial="client.redirect_uris"
              v-else
              description="For Web and Single-page applications privide one or more valid http/https callback URLs, e.g. <pre>https://app.axioms.io/callback</pre>Please <a href='https://developer.axioms.io/docs/getting-started/client/configure/redirect-uris' target='_blank'>→ review the documentation</a> on Client redirect URI schemes."
            />
          </a-collapse-panel>
          <a-collapse-panel header="Logout Redirect URIs" key="4">
            <a-multiple-urls
              :form="form"
              varName="post_logout_redirect_uris"
              varLabel="Signout Redirect"
              :varInitial="client.post_logout_redirect_uris"
            />
          </a-collapse-panel>
          <a-collapse-panel header="ID Token Options" key="5">
            <a-id-token-options :formLayout="formLayout" :size="size" :data="client" />
          </a-collapse-panel>
          <a-collapse-panel header="Branding Options" key="6">
            <a-branding-options :formLayout="formLayout" :size="size" :data="client" />
          </a-collapse-panel>
        </a-collapse>
        <a-form-item
          :wrapper-col="buttonItemLayout.wrapperCol"
          style="margin-top:0.5em;float: left;"
        >
          <a-button type="primary" shape="round" size="large" @click="handleSubmit">Update Details</a-button>
        </a-form-item>
      </a-form>
    </a-skeleton>
    <a-popconfirm
      v-if="!loading"
      placement="left"
      okText="Yes"
      cancelText="No"
      style="margin-top: 8px; margin-left: 30px; float: right;"
      @confirm="handleDelete"
    >
      <p slot="title" style="font-size:14px;">Do you want to delete this client？</p>
      <a-icon slot="icon" type="question-circle-o" style="color: red" />
      <a-button type="danger" size="large">Delete client</a-button>
    </a-popconfirm>
  </div>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";
import ABrandingOptions from "@/components/FormSet/ABrandingOptions";
import AClientGeneral from "@/components/FormSet/AClientGeneral";
import AClientClaims from "@/components/FormSet/AClientClaims";
import AMultipleUrls from "@/components/FormSet/AMultipleUrls";
import AIdTokenOptions from "@/components/FormSet/AIdTokenOptions";

export default {
  data() {
    return {
      componentKey: 10,
      loading: true,
      size: "large",
      formLayout: "horizontal",
      form: this.$form.createForm(this)
    };
  },
  mixins: [formLayoutMixin],

  components: {
    ABrandingOptions,
    AClientGeneral,
    AMultipleUrls,
    AIdTokenOptions,
    AClientClaims
  },

  computed: {
    client() {
      return this.$store.state.tenant.clients_item
        ? this.$store.state.tenant.clients_item
        : {};
    },
    options() {
      return this.$store.state.tenant.clients_options.actions.POST;
    }
  },

  methods: {
    async handleDelete() {
      try {
        await this.$store.dispatch("tenant/deleteItem", {
          endpoint: "clients",
          uuid: this.$route.params.uuid
        });
        await this.$router.push("/clients");
        await this.$notification.open({
          message: "Client delete!",
          description: "Client was deleted.",
          icon: (
            <a-icon type="check-circle" theme="filled" style="color: green" />
          )
        });
      } catch (error) {
        console.error(error);
      }
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await this.$store.dispatch("tenant/patchItem", {
              endpoint: "clients",
              uuid: this.$route.params.uuid,
              data: values
            });
            await this.$notification.open({
              message: "Updated!",
              description: "Client settings updated",
              icon: (
                <a-icon
                  type="check-circle"
                  theme="filled"
                  style="color: green"
                />
              )
            });
          } catch (error) {
            console.error(error);
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    },
    success() {
      this.$message.success("Copied.", 5);
    },
    forceRerender() {
      this.componentKey += 1;
    }
  },

  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("tenant/getItem", {
        endpoint: "clients",
        uuid: this.$route.params.uuid
      });
      this.loading = false;
      this.name = this.client.name;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>
